
// 将所有具有  .ani  类的元素隐藏，并将它们的样式缓存起来。
export function swiperAnimateCache() {
    const allBoxes = document.querySelectorAll('.ani')
    allBoxes.forEach((element) => {
      const styleValue = element.getAttribute('style') || ''
      element.setAttribute('swiper-animate-style-cache', styleValue)
      // element.style.visibility = 'hidden'
    })
  }
   
  // 根据传入的 Swiper 实例  a ，为当前活动幻灯片中的所有具有  .ani  类的元素添加动画效果。
  // 它会根据元素的属性设置动画的持续时间、延迟和效果，并将元素的样式设置为可见。
  export function swiperAnimate(a) {
    clearSwiperAnimate()
    const activeSlide = a.slides[a.activeIndex]
    const animatedElements = activeSlide.querySelectorAll('.ani')
    animatedElements.forEach((element) => {
      element.style.visibility = 'visible'
      const effect = element.getAttribute('swiper-animate-effect') || ''
      element.classList.add('animated', effect)
      const duration = element.getAttribute('swiper-animate-duration') || ''
      const delay = element.getAttribute('swiper-animate-delay') || ''
      const style = `${
        element.getAttribute('style') || ''
      } animation-duration: ${duration}; -webkit-animation-duration: ${duration}; animation-delay: ${delay}; -webkit-animation-delay: ${delay};`
      element.setAttribute('style', style)
    })
  }
  // 清除所有具有  .ani  类的元素的动画效果。它会恢复元素的初始样式，并将元素隐藏起来。
  export function clearSwiperAnimate() {
    const allBoxes = document.querySelectorAll('.ani')
    allBoxes.forEach((element) => {
      const styleCache = element.getAttribute('swiper-animate-style-cache')
      if (styleCache) {
        element.setAttribute('style', styleCache)
      }
      // element.style.visibility = 'hidden'
      element.classList.remove('animated')
      const effectValue = element.getAttribute('swiper-animate-effect')
      if (effectValue) {
        element.classList.remove(effectValue)
      }
    })
  }
   